<template>
  <c-view>
    <c-page>
      <c-navbar></c-navbar> 
      <iframe v-if="src" frameborder="0" scrolling="yes" class="full-frame"
              :src="src"></iframe>
    </c-page>
  </c-view>
</template>
<style lang="scss" scoped>
  @import './index.scss';
</style>
<script>
  import { mapState } from 'vuex'

  export default {
    data () {
      return {}
    },
    components: {},
    created () {},
    mounted () {},
    beforeDestroy () {},
    methods: {},
    computed: {
      ...mapState({
        src: state => state.innerWebView.src
      })
    },
    watch: {}
  }
</script>



// WEBPACK FOOTER //
// index.vue?28d3a4b4